import { apiRequest } from './client'

export interface WorksSquareRegion {
  key: string
  label: string
  flag?: string
  enabled?: boolean
  keywords?: string[]
}

export interface WorksSquareConfig {
  title: string
  subtitle: string
  empty: string
  default_order_by: 'curated' | 'published_at' | 'view_count' | 'like_count' | 'created_at'
  show_category_tabs?: boolean
  page_size?: number
  regions?: WorksSquareRegion[]
  locale?: string
}

export const worksSquareApi = {
  config: () => apiRequest<WorksSquareConfig>('/api/v1/works/square-config', { auth: false }),
}
